import "../index.css";
import { useState } from "react";
import Button from "../components/button/button";
import PolicyContainer from "../components/policy/policyContainer";
import axios from "axios";
import { baseURL } from "../baseURL";
import ReferralMultiSelect from "./formFields/referralMultiSelect";
import {
  buildDownloadPayload,
  validateDownloadForm,
} from "./formFields/downloadFormUtils";

const PopUpScorecardFormDownloadScorecard = ({ onClose, onSuccess, onError }) => {
  const [formData, setFormData] = useState({});
  const [formError, setFormError] = useState("");

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleReferralChange = (sources) => {
    setFormData((prevData) => ({
      ...prevData,
      referralSources: sources,
      // drop the "please mention where" text if "Other" is unticked
      referralOther: sources.includes("Other") ? prevData.referralOther : "",
    }));
  };

  const handleReferralOtherChange = (text) => {
    setFormData((prevData) => ({ ...prevData, referralOther: text }));
  };

  const handleSubmitDownloadForm = async (e) => {
    e.preventDefault();

    const payload = {
      ...buildDownloadPayload(formData),
      submissionType: "downloadScorecard",
      scorecardForm: true,
    };

    const validationError = validateDownloadForm(payload);
    if (validationError) {
      setFormError(validationError);
      return;
    }
    setFormError("");

    try {
      const response = await axios.post(
        `${baseURL}/api/submit-download-form`,
        payload,
        {
          withCredentials: "true", // This matches the backend CORS policy
          headers: { "Content-Type": "application/json" },
        }
      );

      if (response.status === 200) {
        onSuccess("scorecard-download");
        onClose();
      }
    } catch (error) {
      console.error("Error submitting form:", error.response || error.message);
      onError(error);
    }
  };

  return (
    <>
      <div className="pop-up-form">
        <div className="form-header">
          <h4>Download the Scorecard</h4>
          <div className="close-btn-x" onClick={onClose}>
            <i className="fa-solid fa-xmark"></i>
          </div>
        </div>
        <form id="scorecardForm" onSubmit={handleSubmitDownloadForm}>
          <p>
            Providing your contact information enables us to share best
            practices, communicate updates, and network with our global wildfire
            prevention community.
          </p>
          <div className="form-group">
            <label htmlFor="firstName">*First Name </label>
            <input
              type="text"
              id="firstName"
              name="firstName"
              onChange={handleChange}
              value={formData.firstName || ""}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="lastName">*Last Name</label>
            <input
              type="text"
              id="lastName"
              name="lastName"
              onChange={handleChange}
              value={formData.lastName || ""}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="email">*Email</label>
            <input
              type="email"
              id="email"
              name="email"
              onChange={handleChange}
              value={formData.email || ""}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="organization">Organization</label>
            <input
              type="text"
              id="organization"
              name="organization"
              onChange={handleChange}
              value={formData.organization || ""}
            />
          </div>
          <div className="form-group">
            <label htmlFor="role">Role</label>
            <input
              type="text"
              id="role"
              name="role"
              onChange={handleChange}
              value={formData.role || ""}
            />
          </div>
          <div className="form-group">
            <label htmlFor="zipCode">*Zip/Postal Code</label>
            <input
              type="text"
              id="zipCode"
              name="zipCode"
              onChange={handleChange}
              value={formData.zipCode || ""}
              required
              minLength={4}
            />
          </div>
          <div className="form-group">
            <label htmlFor="communityName">*Community Name</label>
            <input
              type="text"
              id="communityName"
              name="communityName"
              onChange={handleChange}
              value={formData.communityName || ""}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="mobileNumber">Mobile Number</label>
            <input
              type="tel"
              id="mobileNumber"
              name="mobileNumber"
              onChange={handleChange}
              value={formData.mobileNumber || ""}
              maxLength={20}
            />
          </div>
          <ReferralMultiSelect
            selected={formData.referralSources || []}
            otherText={formData.referralOther || ""}
            onChange={handleReferralChange}
            onOtherChange={handleReferralOtherChange}
          />
          <div className="form-group">
            <label htmlFor="message">Message</label>
            <textarea
              id="message"
              name="message"
              cols="50"
              onChange={handleChange}
              value={formData.message || ""}
            ></textarea>
          </div>
          <div className="form-check">
            <input
              type="checkbox"
              id="subscribe"
              name="subscribe"
              onChange={handleChange}
              checked={!!formData.subscribe}
            />
            <label htmlFor="subscribe">Subscribe</label>
          </div>
          <div className="form-check">
            <input
              type="checkbox"
              id="collaborationInterest"
              name="collaborationInterest"
              onChange={handleChange}
              checked={!!formData.collaborationInterest}
            />
            <label htmlFor="collaborationInterest">
              Interested in collaborating with CWPC &amp; ARISE-US?
            </label>
          </div>
          {formError && (
            <div className="form-error" role="alert">
              {formError}
            </div>
          )}
          <Button
            text="Download Scorecard"
            color="var(--green)"
            className="pop-up-btn"
          ></Button>
        </form>
        <div className="policy">
          <PolicyContainer text="Download" />
        </div>
        <div className="form-footer">
          <div className="form-close-btn" onClick={onClose}>
            Close
          </div>
        </div>
      </div>
    </>
  );
};

export default PopUpScorecardFormDownloadScorecard;
